import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InactivityTimer from './InactivityTimer';

const PaymentCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [status, setStatus] = useState(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        const paymentId = searchParams.get('payment_id');
        const orderId = searchParams.get('order_id');
        const signature = searchParams.get('signature');

        if (!paymentId || !orderId || !signature) {
            setStatus('failure');
            return;
        }

        // Backend handlePaymentCallback redirects to the correct success/failure page.
        // Full-page POST avoids CORS issues with redirect Location headers.
        const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${backendUrl}/api/patient/verify-payment`;
        form.style.display = 'none';

        const fields = {
            razorpay_order_id: orderId,
            razorpay_payment_id: paymentId,
            razorpay_signature: signature,
        };

        Object.entries(fields).forEach(([name, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
    }, [location]);

    if (status === 'failure') {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-red-50">
                <h2 className="text-2xl text-red-600 font-bold">Payment Failed</h2>
                <p className="mt-2 text-gray-700">Missing payment details. Please try again.</p>
                <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
                    Go Home
                </button>
            </div>
        );
    }

    return (
        <>
            <InactivityTimer />
            <div className="flex justify-center items-center h-screen">
                <p className="text-lg">Verifying payment...</p>
                <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin ml-2"></div>
            </div>
        </>
    );
};

export default PaymentCallback;
